import type { BoomHelpScreen } from "api/boom-help/types";

export const SCREEN_SCHEME = "boom-help-screen:";
const SCREEN_TOKEN = /\[\[screen:([a-z0-9_.-]+)\]\]/gi;

export const toMarkdownWithScreenLinks = (
  content: string,
  screens: BoomHelpScreen[]
) => {
  const byId = new Map(screens.map((screen) => [screen.id, screen]));
  return content.replace(SCREEN_TOKEN, (_, rawId: string) => {
    const screen = byId.get(rawId.toLowerCase());
    if (!screen) return "";
    const label = screen.label.replace(/[[\]]/g, "");
    return `[${label}](${SCREEN_SCHEME}${screen.id})`;
  });
};
